/* template */
<template><div class="poster-popup"><div class="content"><img :src="(popupData.posterImageUrl)" class="poster-image"/></div><div class="footer"><div class="desc">{{ desc }}</div><mpx-view @tap="close('知道了')" class="btn">知道了</mpx-view></div><mpx-image src="https://ut-static.udache.com/webx/ut/PCthcfJ-MJ5pEZE5HlUhJ.png" @tap="close('叉号')" class="close"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m05d09a42"}'>
  rpx2vh(_rpx)
    (_rpx / 1334 * 100)vh
  .poster-popup
    z-index 9
    position: fixed
    top: 0
    box-sizing: border-box
    width 100vw
    height 100vh
    background-color: rgba(0, 0, 0, .8)
    .content
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      height rpx2vh(1034)
    .title
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: rpx2vh(46);
      color: #FFF;
      letter-spacing: rpx2vh(2.19);
      text-align: center;
      background url('https://ut-static.udache.com/webx/ut/jH_q77p0Kadgl8bK9Rq2n.png')
      background-size cover
      width rpx2vh(448)
      height rpx2vh(70)
      line-height rpx2vh(70)
      margin-bottom rpx2vh(40)
    .footer
      width 750rpx
      // height: 22.49vh
      height: rpx2vh(300)
      position absolute
      bottom 0
      background-image: linear-gradient(180deg, #FFFFFF 2%, #FFFFFF 41%);
      box-shadow: inset 0px 2rpx 0px 0px rgba(255,255,255,1)
      border-radius: 40rpx 40rpx 0px 0px;
      .btn
        width: rpx2vh(500);
        height: rpx2vh(100);
        background-image: linear-gradient(256deg, #FF6B00 0%, #FF5000 77%);
        border-radius: 50rpx;
        font-family: AlibabaPuHuiTi-Medium;
        font-size: rpx2vh(42);
        color: #FFF;
        text-align: center;
        font-weight: 500;
        line-height rpx2vh(100)
        position absolute
        bottom rpx2vh(40)
        left: 50%;
        transform: translateX(-50%);
      .desc
        font-family: PingFangSC-Regular;
        font-size: rpx2vh(32);
        color: #000;
        letter-spacing: 2rpx;
        text-align: center;
        white-space pre-line
        height rpx2vh(160)
        display: flex;
        align-items: center;
        justify-content: center;
    .poster-image
      width: rpx2vh(450)
      height: rpx2vh(800)
      border-radius: 36rpx
      border: rpx2vh(10) solid #fff;
      // border-bottom: none;
      flex-shrink 0
    .close
      width: 41rpx
      height: 41rpx
      position absolute
      top 80rpx
      right 60rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m05d09a42"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./poster-popup.mpx.js?isComponent&outputPath=components%2Fposter-popup05d09a42%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./poster-popup.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fposter-popup05d09a42%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m05d09a42"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/poster-popup05d09a42/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
